import React from "react";
import ReactDOM from "react-dom";
import { Button, Drawer, Modal } from "antd";
import { store } from "@/redux/store";
import "./responsiveConfirm.css";

const nativeConfirm = Modal.confirm.bind(Modal);
let patched = false;

const isH5 = () => store.getState()?.App?.isPC === false;

const ResponsiveConfirmDrawer = ({ config, destroy }) => {
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const close = () => setOpen(false);
  const handleCancel = () => {
    config.onCancel?.();
    close();
  };
  const handleOk = async () => {
    try {
      setLoading(true);
      await config.onOk?.();
      close();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      open={open}
      visible={open}
      title={config.title}
      placement="bottom"
      height="auto"
      zIndex={config.zIndex}
      onClose={handleCancel}
      afterVisibleChange={(nextOpen) => {
        if (!nextOpen) destroy();
      }}
      afterOpenChange={(nextOpen) => {
        if (!nextOpen) destroy();
      }}
      className={`responsive-confirm-drawer ${config.className || ""}`}
      destroyOnClose
    >
      {config.content ? (
        <div className="responsive-confirm-drawer__content">
          {config.content}
        </div>
      ) : null}
      <div className="responsive-confirm-drawer__footer">
        <Button onClick={handleCancel}>{config.cancelText || "Cancel"}</Button>
        <Button
          type="primary"
          danger={config.okType === "danger"}
          loading={loading}
          onClick={handleOk}
        >
          {config.okText || "OK"}
        </Button>
      </div>
    </Drawer>
  );
};

export const responsiveConfirm = (config) => {
  if (!isH5()) {
    return nativeConfirm(config);
  }

  const container = document.createElement("div");
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.parentNode?.removeChild(container);
  };

  ReactDOM.render(
    <ResponsiveConfirmDrawer config={config} destroy={destroy} />,
    container
  );

  return {
    destroy,
    update: () => {},
  };
};

export const setupResponsiveConfirm = () => {
  if (patched) return;
  patched = true;
  Modal.confirm = responsiveConfirm;
};

export default responsiveConfirm;
